module.exports = __webpack_public_path__ + "img/discountCouponIcon.32bc2ac8.svg";